import React from "react";
import { motion, Variants, Transition } from "framer-motion";
import "./page.scss";

const pageVariants: Variants = {
    in: {
        opacity: 1
    },
    out: {
        opacity: 0
    }
};

const pageTransition: Transition = {
    duration: 0.2
}

type PageProps = { };

export const Page: React.FC<PageProps> = ({ children }) => {
    return (
        <div className="page">
            <motion.div initial="out" exit="out" animate="in" variants={pageVariants} transition={pageTransition}>
                {children}
            </motion.div>
        </div>
    );
}
